var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1369 7.13948C12.8772 6.87979 12.4561 6.87979 12.1965 7.13948C11.9369 7.39901 11.9367 7.81972 12.196 8.07948L15.4467 11.3359L6.66667 11.3359C6.29848 11.3359 6 11.6344 6 12.0026C6 12.3708 6.29848 12.6693 6.66667 12.6693L15.4467 12.6693L12.194 15.9162C11.9323 16.1774 11.9321 16.6014 12.1935 16.8628C12.4548 17.1241 12.8785 17.1241 13.1398 16.8628L16.5858 13.4168C17.3668 12.6358 17.3668 11.3694 16.5858 10.5884L13.1369 7.13948Z",
    fill: "#40437A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/redirect-icon.84359a67.svg";
export { ForwardRef as ReactComponent };